import React from "react";

// Módulos con evidencias leídas (mismas claves que server/services/evidenceReader.js)
export const EVIDENCE_MODULES = [
  { value: "annualPlan",       labelKey: "annual_plan" },
  { value: "legalRequirement", labelKey: "legal_requirements" },
  { value: "accident",         labelKey: "accident_management" },
  { value: "workPermit",       labelKey: "work_permits" },
  { value: "actionPlan",       labelKey: "action_plan_management" },
  { value: "inspection",       labelKey: "ev_mod_inspection" },
  // Los módulos de Debida Diligencia no se leen como evidencia (pedido del cliente)
];

// Estados de vigencia (calculados en el servidor, ver evidenceValidity en evidenceReader.js)
export const EVIDENCE_VALIDITIES = ["expired", "expiring", "outdated", "valid"];

// Link al registro dueño de la evidencia, por módulo. Permisos de Trabajo y
// Check list tienen pantalla propia por registro; los demás son listados sin
// ruta propia, así que se abren con ?open=<id> (ver el efecto que lo lee en
// cada *Table.js) — mismo mecanismo que ya usa el ?open=modulo:fileKey de la
// campanita para abrir el visor de evidencias.
export function evidenceDocumentUrl(module, refId) {
  if (!refId) return null;
  switch (module) {
    case "workPermit":       return `/admin/work-permits/${refId}`;
    case "inspection":       return `/inspect/${refId}`;
    case "actionPlan":       return `/admin/action-plans?open=${refId}`;
    case "accident":         return `/admin/accidents?open=${refId}`;
    case "annualPlan":       return `/admin/annual-plan?open=${refId}`;
    case "legalRequirement": return `/admin/legal-requirements?open=${refId}`;
    default: return null;
  }
}

export function validityLabelKey(validity) {
  return `ev_validity_${validity}`;
}

export function moduleLabelKey(module) {
  return EVIDENCE_MODULES.find((m) => m.value === module)?.labelKey || module;
}

export function formatDate(d) {
  if (!d) return "";
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("es-AR", { timeZone: "UTC", day: "2-digit", month: "2-digit", year: "numeric" });
}

const ACCENTS = { a: "aáàäâ", e: "eéèëê", i: "iíìïî", o: "oóòöô", u: "uúùüû", n: "nñ", c: "cç" };

function stripAccents(s) {
  return String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "");
}

// Regex que encuentra cualquiera de las palabras, sin importar mayúsculas ni acentos
export function buildTermsRegex(query) {
  const words = stripAccents(query).toLowerCase().split(/\s+/).filter((w) => w.length > 1);
  if (!words.length) return null;
  const parts = words.map((w) =>
    w.split("").map((ch) => {
      if (ACCENTS[ch]) return `[${ACCENTS[ch]}${ACCENTS[ch].toUpperCase()}]`;
      return ch.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }).join("")
  );
  return new RegExp(`(${parts.join("|")})`, "gi");
}

// Devuelve el texto con las coincidencias envueltas en <mark>
export function highlight(text, query, markClassName = "ev-mark") {
  const re = buildTermsRegex(query);
  const str = String(text || "");
  if (!re) return str;
  const out = [];
  let last = 0;
  let i = 0;
  str.replace(re, (match, _g, offset) => {
    if (offset > last) out.push(str.slice(last, offset));
    out.push(<mark key={i++} className={markClassName}>{match}</mark>);
    last = offset + match.length;
    return match;
  });
  if (last < str.length) out.push(str.slice(last));
  return out;
}

export function countMatches(text, query) {
  const re = buildTermsRegex(query);
  if (!re) return 0;
  return (String(text || "").match(re) || []).length;
}

// Tipo de archivo a partir del nombre — para decidir cómo previsualizarlo
export function isImageFile(fileName) {
  return /\.(jpe?g|png|gif|webp|bmp)$/i.test(String(fileName || ""));
}

export function isPdfFile(fileName) {
  return /\.pdf$/i.test(String(fileName || ""));
}
